<template>
  <section class="upload-image">
    <DropImages
      ref="dropImages"
      :name="inputName"
      style="height: 240px;"
      @filesLoad="onFilesLoad"
    />
    <button
      ref="button"
      style="display: none"
      type="submit"
    />
  </section>
</template>

<script>

    import DropImages from '../DropImages.vue'

    export default {
        name: 'UploadImage',
        components: { DropImages },
        props: {
          inputName: {
             default: 'factory[factory_images_attributes][][image]',
             type: String,
          },
        },
        methods: {
            onFilesLoad() {
              this.$refs.button.click()
            },
        },
    }
</script>

<style scoped>

</style>
